import { Page } from '@borg/types';

class InfoPagesRepository extends Repository<Page> {
    get(slug: string) {
        return this._get({ url: `/apps/pages/${slug}` });
    }
}

export const infoPagesRepository = new InfoPagesRepository();
